import cx from "classnames";
import { ReactElement, useEffect, useRef, useState } from "react";

import SPHLogo from "../../assets/SPH24-Logo.svg";
import { SUPPORTED_LANGS } from "./constants";
import { useLandingLang, useLandingTranslation } from "./landingLang";

import styles from "./LandingPage.module.scss";

export default function LandingHeader(): ReactElement {
  const { t } = useLandingTranslation();
  const currentLang = useLandingLang();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const changeLanguage = (lang: string) => {
    setIsOpen(false);
    if (lang === "en") {
      window.location.href = "/";
    } else {
      window.location.href = `/landing/${lang}`;
    }
  };

  return (
    <header className={styles.header}>
      <img src={SPHLogo} alt="SPH Media" className={styles.headerLogo} />

      <div className={styles.headerActions}>
        <div className={styles.langDropdownContainer} ref={dropdownRef}>
          <button
            className={styles.langSelect}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            aria-expanded={isOpen}
            aria-haspopup="listbox"
          >
            {t(`language.${currentLang}`)}
            <svg
              className={cx(styles.chevron, { [styles.chevronOpen]: isOpen })}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 9.5L12 14.5L16.5 9.5"
                stroke="#636369"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {isOpen && (
            <div className={styles.dropdownMenu} role="listbox">
              {SUPPORTED_LANGS.map((lang) => (
                <button
                  key={lang}
                  role="option"
                  aria-selected={currentLang === lang}
                  className={cx(styles.dropdownItem, {
                    [styles.dropdownItemActive]: currentLang === lang,
                  })}
                  onClick={() => {
                    changeLanguage(lang);
                  }}
                >
                  {t(`language.${lang}`)}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
